import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-marketing-visit',
  templateUrl: './marketing-visit.component.html',
  styleUrls: ['./marketing-visit.component.css']
})
export class MarketingVisitComponent implements OnInit {

  output:any =[];
  isLoader = false;
  body = true
  search: string = '';

  constructor(private service: ServiceService, private route: ActivatedRoute, private router: Router) {
    
  }


//excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('MKV');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('MKV.' + ('xlsx')));


  }

      //-------------function for search--------------------
Search(){
  console.log("click search",this.search);
  if(this.search=='')
  {
  this.service.listMarketingVisit().subscribe((res)=>{
  this.output=res.data
  })
 
}
else{
   //-------api get()calling-------------
   this.service.listMarketingVisitSearch(this.search).subscribe((res)=>{
   this.output=res.data
   console.log("click search",res.data);

  })
}
}


  ngOnInit(): void {

    this.service.listMarketingVisit().subscribe((res)=>{
          this.output=res.data
          console.log("data=",this.output)
          console.log("res=",res)         
          })  
    }

  }
